import * as React from "react";
import { Container, Typography, Box, Paper, Stack, Chip } from "@mui/material";
import { PlacementTestResult } from "../../types/PlacementTest";

interface Props {
  result: PlacementTestResult;
}

const PlacementTestResultPage: React.FC<Props> = ({ result }) => {
  //remove below

  return (
    <Container maxWidth="sm" sx={{ mt: 8, mb: 4 }}>
      <Typography variant="h4" align="center" gutterBottom>
        Placement Test Result
      </Typography>

      <Paper elevation={3} sx={{ p: 3 }}>
        <Stack direction="column" spacing={3} alignItems="center">
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            sx={{ width: "100%", justifyContent: "space-between" }}
          >
            <Typography variant="h6">Easy Questions Score:</Typography>
            <Chip label={result.easyCorrect} color="success" />
          </Stack>
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            sx={{ width: "100%", justifyContent: "space-between" }}
          >
            <Typography variant="h6">Hard Questions Score:</Typography>
            <Chip label={result.hardCorrect} color="warning" />
          </Stack>
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            sx={{ width: "100%", justifyContent: "space-between" }}
          >
            <Typography variant="h6">Assigned Programme:</Typography>
            <Typography variant="subtitle1" color="primary">
              {result.programName}
            </Typography>
          </Stack>
        </Stack>
      </Paper>
    </Container>
  );
};

export default PlacementTestResultPage;
